import React, { useState } from 'react';
import logo from '../assets/images/logo.svg';  
import '../assets/css/styles.css'; 


const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Toggle menu visibility on small screens
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <nav>
        <div className="logo-container">
          <img src={logo} alt="Codelithic Labs Logo" className="logo" />
        </div>
        <div className="hamburger-menu" onClick={toggleMenu}>
          <span className="hamburger-icon">&#9776;</span>  {/* Hamburger icon */}
        </div>
        <ul className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
          <li><a href="/#">Home</a></li>
          <li><a href="/#about">About</a></li>
          <li><a href="/#services">Services</a></li>
          {/* <li className="dropdown">
            <a href="/#">Solutions <span className="arrow">&#9660;</span></a>
            <ul className="dropdown-menu">
              <li><a href="/#">Farms </a></li>
            </ul>
          </li> */}
          <li><a href="/#footer">Contact</a></li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;


